/*
multi-round.component.ts
Golfhubber
Created by Chetan Baghel on 23/06/2021.
Copyright © 2021 Golfhubber Ltd. All rights reserved.
*/
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database';
import { Tournament } from 'app/models/tournament';
import { ApiService } from 'app/services/api';
import { ElasticService } from 'app/services/elastic';
import { OAuthService } from 'app/services/o-auth';
import * as lodash from "lodash";
import * as moment from "moment";
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-multi-round',
  templateUrl: './multi-round.component.html',
  styleUrls: ['./multi-round.component.scss']
})
export class MultiRoundComponent implements OnInit {

  public filterargs: any;

  public imageLoader = false;
  public tournaments: Array<any>;
  public maxPage: number;
  public typingDelay: any;
  public pageSize: number;
  public currentPage;
  public GridView = false;
  public user: any;
  public permissions: any = {};
  constructor(
    private elasticService: ElasticService,
    private apiService: ApiService,
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService,
    private datePipe: DatePipe,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.filterargs = new Tournament();
    this.currentPage = 0;
    this.pageSize = 30;
  }

  public showAction = -1;

  onshowAction(i)
  {    
    this.showAction = i;
  }

  closeAction(event) {
    this.showAction = -1;
  }

  async ngOnInit() {
    this.user = this.oAuthService.getClub();
    
    this.fireDatabase.object(`user-permissions/${this.user.uid}/${this.user.cid}/tournaments`).subscribe(result => {
      if (this.user.type == 3 && this.user.role == 1) {
        this.permissions["read"] = true;
        this.permissions["update"] = true;
        this.permissions["create"] = true;
        this.permissions["delete"] = true;
      }
      else
        this.permissions = result;
      this.goToPage(0);
    });
  }

  public filterChange() {
    // this.filterargs.startDate = this.datePipe.transform(event, 'yyyy-MM-dd')
    this.goToPage(0);
  }

  public clearMultiRoundTournament(id) {
    if (confirm("Are you sure? You want to clear the tournament, it is a multiround tournament, its sub-sequent round tournaments will also be cleared")) {
      this.fireDatabase.database.ref(`/multi-round/${id}/tournamentsRound`).once("value", result => {
        let rounds = result.val();
        if (rounds.length) {
          rounds.forEach(element => {
            this.clearTournament(element);
          })
        }
      });
    }
  }

  public deleteMultiRoundTournament(id) {
    if (confirm("Are you sure? You want to delete this tournament, it is a multiround tournament, its sub-sequent round tournaments will also be deleted")) {
      
      this.apiService.set(`/multi-round/${id}/isDeleted`, true);
      this.fireDatabase.database.ref(`/multi-round/${id}/tournamentsRound`).once("value", result => {
        let rounds = result.val();
        if (rounds.length) {
          rounds.forEach(element => {
            this.deleteTournament(element);
          })
        }
      });
      location.reload();
    }
  }

  public clearTournament(id) {
    this.apiService.set(`server-process/clear-tournament/${id}`, id);
  }

  public deleteTournament(id) {
      this.apiService.set(`/tournaments/${id}/isDelete`, true);
      this.apiService.set(`server-process/clear-tournament/${id}`, id);
  }

  displayDate(startDate)
  {
    if(!startDate) return "N/A"
    const date = new Date(startDate*1000);
    return date.getFullYear() +
                "-" +
                ("0" + (date.getMonth() + 1)).slice(-2) +
                "-" +
                ("0" + date.getDate()).slice(-2);
  }

  async displayStatus(tournament)
  {
    if (!tournament.startDate)
      return "Unknown"
    const current = new Date().getTime();
    if (current > tournament.endDate * 1000)
      return "Finished"
    else if (tournament.startDate * 1000 > current)
    {
      const days = Math.floor(
                  Math.abs((tournament.startDate*1000 - current) / (24 * 60 * 60 * 1000))
                );
                if (days < 1) {
                  return await this.getTimeDifference(tournament.startDate*1000) + "to start";
                } else {
                  return await this.getTimeDifference(tournament.startDate*1000) + "to start";
                }
      }
    else return "Active"
  }
  

  async goToPage(index: number) {
    
    const fromIndex = index * this.pageSize;

    let ref = this.fireDatabase.database.ref(`/multi-round/`);
    ref.once("value", (result) => {
      this.tournaments = [];
      let future_tournaments = []; let active_tournaments = [];
      if (result.val()) {
        lodash.forEach(result.val(), (element, key) => {
          Object.assign(element, { $key: key });
          Object.assign(element, { displayStartDate: this.displayDate(element.startDate) })
          let status;
          let sort;
          const current = new Date().getTime();
          if (!element.startDate) {
            status = "Unknown"
            sort = 3
          }
          else if (current > element.endDate * 1000) {
            status = "Finished"
            sort = 3
          }
          else if (element.startDate * 1000 > current) {
            const days = Math.floor(
              Math.abs((element.startDate * 1000 - current) / (24 * 60 * 60 * 1000))
            );
            if (days < 1) {
              status = this.getTimeDifference(element.startDate) + "to start";
            }
            else {
              status = this.getTimeDifference(element.startDate) + "to start";
            }
            sort = 1
          }
          else {
            status = "Active"
            sort = 2
          }
          Object.assign(element, { displayStatus: status,  sort: sort})
          if (element.isDeleted == undefined || element.isDeleted == false)
          {
            if (this.filterargs.startDate)
            {
              let tstartDate:any = this.filterargs.startDate;
              let tendDate: any;
              let val = tstartDate
              tstartDate = this.datePipe.transform(val, "yyyy-MM-dd")
              const startDate = new Date(tstartDate);
              const sdate = moment(startDate).format("YYYY-MM-DD");
              const sdateTime = moment(
                `${sdate}`,
                "YYYY-MM-DD HH:mm A"
              );
              const edate = moment(startDate).format("YYYY-MM-DD");
              const edateTime = moment(
                `${edate}${23}:${59}`,
                "YYYY-MM-DD HH:mm"
              );
              tendDate = edateTime.unix();
              tstartDate = sdateTime.unix();

              if (element.startDate>= tstartDate && element.startDate <= tendDate)
              {
                this.tournaments.push(element);
              }
            }
            else
            this.tournaments.push(element);
          }
        });
      }
      else {
        this.tournaments = [];
      }
      this.tournaments.sort((a, b) => {
        return b.startDate - a.startDate
      });
      this.tournaments.sort((a, b) => {
        return a.sort - b.sort
      });
      this.imageLoader = false;
    });
  }

  public getTimeDifference(givenTime: number) {
    const current = new Date().getTime() / 1000;
    const min = Math.abs((current - givenTime) / 60);
    const hour = min / 60;
    const day = hour / 24;
    const month = day / 30;
    const year = month / 12;
    if (year < 1) {
      if (month < 1) {
        if (day < 1) {
          if (hour < 1) {
            if (min > 10) {
              return parseInt(min + "") + " min ";
            } else {
              return "few mins ";
            }
          } else {
            if (hour < 2) {
              return parseInt(hour + "") + " hr ";
            } else {
              return parseInt(hour + "") + " hrs ";
            }
          }
        } else {
          const d = parseInt(day + "");
          const rh = parseInt(hour - 24 * d + "");
          if (day < 2) {
            return d + " day " + rh + " hrs ";
          } else {
            return d + " day " + rh + " hrs ";
          }
        }
      } else {
        if (month < 2) {
          return parseInt(month + "") + " month ";
        } else {
          return parseInt(month + "") + " months ";
        }
      }
    } else {
      if (year < 2) {
        return parseInt(year + "") + " year ";
      } else {
        return parseInt(year + "") + " years ";
      }
    }
  }

  goNext() {
    const index = this.currentPage + 1;
    this.goToPage(index);
  }

  goPrev() {
    const index = this.currentPage - 1;
    this.goToPage(index);
  }

  getIndex(index: number) {
    return this.currentPage * this.pageSize + index + 1;
  }

  changeQuery() {
    clearTimeout(this.typingDelay);

    this.typingDelay = setTimeout(() => {
      this.currentPage = 0;
      this.goToPage(this.currentPage);
    }, 400);
  }

  reset() {
    this.filterargs = new Tournament();
    this.filterChange();
  }

  onShowClick(tournament) {
    return `/components/tournamentDetail-multiround/${tournament.$key}`;
  }

}
